import websiteData = require('diy/util/websiteData');
import $ = require("jquery");
import { FeedbackType } from './FeedbackButton';

export function DiyFeedbackSubmit (
    feedbackContext: string,
    feedbackType: FeedbackType,
    feedbackText: string
) {
    const feedbackTypeString = feedbackType === FeedbackType.POSITIVE ? "positive" : "negative";

    return new Promise<string>((resolve, reject) => {
        $.ajax({
            url: "/rest/websites/" + websiteData.getId() + "/feedback",
            type: "POST",
            contentType: "application/json; application/vnd.oneandone.diy.website.feedback+json",
            data: JSON.stringify({
                feedbackContext: feedbackContext,
                feedbackType: feedbackTypeString,
                feedbackText: feedbackText
            }),
            success: () => {
                resolve();
            },
            error: () => {
                reject();
            }
        });
    });
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/feedback/DiyFeedbackSubmit.ts
 **/